<ptl-v3-filter-shell [title]="'translations.reviews.filter.group' | transloco" (applied)="applyFilter()" (deleted)="deleteFilter()">
  <ng-container ngProjectAs="[shell-controls]">
    <ptl-select
      class="v3-group-filter__select"
      [options]="isOptions"
      [ngModel]="groupIs"
      (selectionChange)="onGroupIsChange($event)"
    ></ptl-select>
    @if (groupIs) {
      <ptl-select
        class="v3-group-filter__select"
        [options]="operatorOptions"
        [ngModel]="logicalOperator"
        (selectionChange)="onLogicalOperatorSelection($event)"
      ></ptl-select>
    }
  </ng-container>

  <ptl-sg-input
    [withIcon]="true"
    [icon]="LucideSearch"
    [placeholder]="'translations.reviews.label.searchForGroups' | transloco"
    (inputChange)="onSearchInputChange($event)"
  ></ptl-sg-input>

  <div class="v3-group-filter__list" (scroll)="onResultsScroll($event)">
    @for (group of getSelectedGroupsOutsideResults(); track group._id) {
      <ptl-sg-checkbox class="v3-group-filter__item" [checked]="true" [ariaLabel]="group.title" (checkboxChange)="toggleGroup(group)">
        <span class="v3-group-filter__item-label">{{ group.title }}</span>
      </ptl-sg-checkbox>
    }
    @if (loadingGroups) {
      <div class="v3-group-filter__load-more">
        <span class="v3-group-filter__spinner"></span>
      </div>
    } @else {
      @for (group of foundGroups; track group._id) {
        <ptl-sg-checkbox
          class="v3-group-filter__item"
          [checked]="isGroupSelected(group)"
          [ariaLabel]="group.title"
          (checkboxChange)="toggleGroup(group)"
        >
          <span class="v3-group-filter__item-label">{{ group.title }}</span>
        </ptl-sg-checkbox>
      }
      @if (loadingMoreGroups) {
        <div class="v3-group-filter__load-more">
          <span class="v3-group-filter__spinner"></span>
        </div>
      }
    }
  </div>
</ptl-v3-filter-shell>
